import { render } from "./SchedulingList.vue?vue&type=template&id=afec4942"
import script from "./SchedulingList.vue?vue&type=script&lang=js"
export * from "./SchedulingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__